export function makeRandomString(len: number) {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let s = '';
    for (let i = 0; i < len; ++i) {
        s += chars[Math.floor(Math.random() * chars.length)];
    }
    return s;
}

export function transaction() {
    return makeRandomString(12);
}
